import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RequiredMark, sectionBorder } from "./careersUi";

export function AboutYouSection({ form, set, isMissing }) {
  const hasMissing = isMissing("name") || isMissing("phone") || isMissing("email") || isMissing("current_location");
  return (
    <div className={`bg-white p-6 rounded-2xl border ${sectionBorder(hasMissing)} space-y-4`}>
      <h2 className="font-display font-semibold text-lg">About You</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <Label>Full name<RequiredMark/></Label>
          <Input value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="careers-name" className={isMissing("name") ? "border-amber-400" : ""}/>
        </div>
        <div>
          <Label>Phone<RequiredMark/></Label>
          <Input value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="careers-phone" className={isMissing("phone") ? "border-amber-400" : ""}/>
        </div>
        <div className="sm:col-span-2">
          <Label>Email<RequiredMark/></Label>
          <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="careers-email" className={isMissing("email") ? "border-amber-400" : ""}/>
        </div>
        <div className="sm:col-span-2">
          <Label>Current location (City, State)<RequiredMark/></Label>
          <Input value={form.current_location} onChange={(e) => set("current_location", e.target.value)} placeholder="e.g. Fairfax, VA" data-testid="careers-location" className={isMissing("current_location") ? "border-amber-400" : ""}/>
        </div>
      </div>
    </div>
  );
}
